import { createRouter, createWebHashHistory } from 'vue-router'
import OverviewView from '../views/OverviewView.vue'
import PlanListView from '../views/PlanListView.vue'
import DutyView from '../views/DutyView.vue'
import DutyLeadersView from '../views/DutyLeadersView.vue'
import HazardListView from '../views/HazardListView.vue'
import HazardDetailView from '../views/HazardDetailView.vue'
import InspectRecordListView from '../views/InspectRecordListView.vue'
import InspectRecordDetailView from '../views/InspectRecordDetailView.vue'
import GatherOverviewView from '../views/GatherOverviewView.vue'
import GatherRecordListView from '../views/GatherRecordListView.vue'
import GatherRecordDetailView from '../views/GatherRecordDetailView.vue'
import ProfileView from '../views/ProfileView.vue'

const routes = [
  // 总览（免登录，默认首页）
  { path: '/overview', name: 'overview', component: OverviewView, meta: { title: '总览' } },

  // 巡检模块
  { path: '/plans', name: 'plans', component: PlanListView, meta: { title: '巡检计划' } },
  { path: '/duty', name: 'duty', component: DutyView, meta: { title: '巡检安排' } },
  { path: '/duty-leaders', name: 'dutyLeaders', component: DutyLeadersView, meta: { title: '值班领导' } },
  { path: '/records-inspect', name: 'recordsInspect', component: InspectRecordListView, meta: { title: '巡检记录' } },
  { path: '/record-inspect/:id', name: 'recordInspectDetail', component: InspectRecordDetailView, meta: { title: '巡检记录详情' } },

  // 隐患/异常
  { path: '/hazards', name: 'hazards', component: HazardListView, meta: { title: '异常报告' } },
  { path: '/hazard/:id', name: 'hazardDetail', component: HazardDetailView, meta: { title: '隐患详情' } },

  // 上报信息（信息收集后台，可选数据源，如未配置则隐藏入口）
  { path: '/gather', name: 'gather', component: GatherOverviewView, meta: { title: '上报信息' } },
  { path: '/gather-records', name: 'gatherRecords', component: GatherRecordListView, meta: { title: '上报记录' } },
  { path: '/gather-record/:id', name: 'gatherRecordDetail', component: GatherRecordDetailView, meta: { title: '上报详情' } },

  { path: '/me', name: 'profile', component: ProfileView, meta: { title: '我的' } },

  { path: '/', redirect: '/overview' },
  { path: '/:pathMatch(.*)*', redirect: '/overview' }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to) => {
  if (to.meta && to.meta.title) document.title = to.meta.title
  // 免登录：直接进入
})

export default router
